import { typographyRecipe as o } from "@huspy/briks-core";
import { defineSlotRecipe as t } from "@pandacss/dev";
import { anatomy as r } from "../../node_modules/@ark-ui/anatomy/node_modules/@zag-js/toast/dist/index.mjs";
import { createAnatomy as i } from "../../node_modules/@ark-ui/anatomy/node_modules/@zag-js/anatomy/dist/index.mjs";
const e = i("briks-toast", [...r.keys(), "icon"]), g = t({
  className: "briks-toast",
  slots: e.keys(),
  base: {
    root: {
      paddingY: "2.5",
      paddingX: "4",
      height: "11",
      borderRadius: "2.5",
      width: "max-content",
      "&:has([data-part='toast-icon'])": {
        paddingLeft: "10"
      },
      "&:has([data-part='close-trigger'])": {
        paddingRight: "10"
      }
    },
    title: {
      color: "text-white",
      ...o.size["sans-serif"].lg,
      ...o.weight.semiBold
    },
    icon: {
      position: "absolute",
      top: "3",
      left: "3",
      cursor: "pointer",
      width: "5",
      height: "5"
    },
    closeTrigger: {
      position: "absolute",
      top: "3",
      right: "3",
      cursor: "pointer",
      width: "5",
      height: "5"
    }
  },
  variants: {
    type: {
      success: {
        root: {
          backgroundColor: "bg-success-solid"
        }
      },
      warning: {
        root: {
          backgroundColor: "bg-warning-solid"
        }
      },
      error: {
        root: {
          backgroundColor: "bg-error-solid"
        }
      }
    },
    rounded: {
      true: {
        root: {
          borderRadius: "full"
        }
      }
    }
  }
});
export {
  g as toastRecipe
};
